import React from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { dateFormatter } from "../../../../_helpers/dateFormatter";
import { Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import {
  kanbanAssessmentFilter,
  kanbanInterviewFilter,
  kanbanOfferFilter,
} from "../../../HiringManager/HiringManagerKanboard/consts";
function CandidateKanbanBoard({
  columns,
  onViewApplicantProgressClick,
  onDragEnd,
  checkTags,
  loading,
  onOfferFilterChange,
  onAssessmentFilterChange,
  onInterviewFilterChange,
}) {
  return (
    <div className="d-flex kanboard-row">
      <DragDropContext onDragEnd={onDragEnd}>
        {Object.entries(columns).map(([columnId, column], index) => (
          <div className="kanboard-column" key={columnId}>
            <h3 className={`title w-100  p-3  ${column.label}`}>
              <div className="d-flex align-items-center justify-content-between">
                <span className="mr-2">{column.name}</span>
                <span>({column?.items && column.items.length})</span>
              </div>
              {column.name === "ASSESSMENT" && (
                <div className="select">
                  <select
                    className="border mt-1 px-2 py-1 fs-smallest rounded  text-dark"
                    onChange={onAssessmentFilterChange}
                  >
                    {kanbanAssessmentFilter.map((item) => (
                      <option value={item}>{item} </option>
                    ))}
                  </select>
                </div>
              )}
              {column.name === "INTERVIEW" && (
                <div className="select">
                  <select
                    className="border mt-1 px-2 py-1 fs-smallest rounded  text-dark"
                    onChange={onInterviewFilterChange}
                  >
                    {kanbanInterviewFilter.map((item) => (
                      <option value={item}>{item} </option>
                    ))}
                  </select>
                </div>
              )}
              {column.name === "OFFER" && (
                <div className="select">
                  <select
                    className="border mt-1 px-2 py-1 fs-smallest rounded  text-dark"
                    onChange={onOfferFilterChange}
                  >
                    {kanbanOfferFilter.map((item) => (
                      <option value={item}>{item} </option>
                    ))}
                  </select>
                </div>
              )}
            </h3>
            <Droppable
              droppableId={columnId}
              key={columnId}
              index={index}
              className="bg-grey-3 px-2 py-3"
            >
              {(provided, snapshot) => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  style={{
                    background: snapshot.isDraggingOver ? "#F4F5F7" : "#f4f5f7",
                    minHeight: 300,
                  }}
                  className="task-card-list"
                >
                  {column.loading ? (
                    <div className="d-flex align-items-center justify-content-center mt-3">
                      <Spinner animation="border" variant="primary" />
                    </div>
                  ) : (
                    <>
                      {Array.isArray(column.items) && column.items.length ? (
                        <>
                          {Array.isArray(column.items) &&
                            column.items.map((item, index) => (
                              <Draggable
                                draggableId={item.id.toString()}
                                index={index}
                                key={item.id.toString()}
                              >
                                {(provided, snapshot) => (
                                  <div
                                    ref={provided.innerRef}
                                    snapshot={snapshot}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    className="rounded-lg shadow task-card mb-2 p-3 mx-2"
                                    style={{
                                      userSelect: "none",
                                      backgroundColor: snapshot.isDragging
                                        ? "#e8e9eb"
                                        : "#ffffff",
                                      ...provided.draggableProps.style,
                                    }}
                                  >
                                    {checkTags(column, item)}
                                    {provided.placeholder}

                                    {item?.invite_details?._id && (
                                      <p className="h6 text-grey-4 font-weight-normal">
                                        <span className="bg-grey-2 text-dark border-0 rounded-sm p-1 mt-1 fs-smallest line-height-14 mb-2 text-nowrap">
                                          candidate invited by{" "}
                                          {item?.invite_details?.name}
                                        </span>
                                      </p>
                                    )}
                                    <div className="d-flex justify-content-between align-items-start">
                                      <div>
                                        <button
                                          onClick={() =>
                                            onViewApplicantProgressClick(
                                              item?.id
                                            )
                                          }
                                          className="edit px-0 text-left font-weight-semi border-0 bg-transparent mb-2 text-capitalize"
                                        >
                                          {item?.candidate_details &&
                                            item.candidate_details?.full_name}
                                        </button>
                                        <p className="h6 text-grey-4 font-weight-normal">
                                          {dateFormatter(item?.applied_date)}
                                        </p>
                                      </div>
                                    </div>
                                    <ul className="d-flex align-items-center flex-wrap">
                                      {Array.isArray(
                                        item?.candidate_profile_details
                                          ?.skills &&
                                          item?.candidate_profile_details
                                            ?.skills
                                      ) &&
                                        item?.candidate_profile_details
                                          ?.skills &&
                                        item?.candidate_profile_details?.skills.map(
                                          (skill, index) => (
                                            <>
                                              {skill?.is_primary ? (
                                                <>
                                                  <li className="bg-white border text-grey-4 rounded-pill fs-smallest px-2 py-1 mr-2 my-1 rounded p-1">
                                                    {skill?.skill_name}
                                                  </li>
                                                </>
                                              ) : null}
                                            </>
                                          )
                                        )}
                                    </ul>
                                  </div>
                                )}
                              </Draggable>
                            ))}
                        </>
                      ) : (
                        <div className="text-center rounded p-3 mx-2 mt-5">
                          <img
                            src={`/assets/images/${column.name}.svg`}
                            alt="no candidate"
                          />

                          {column.name === "APPLIED" ? (
                            <div>
                              {" "}
                              <h4 className="mb-2">
                                No Candidates Applied Yet
                              </h4>
                              <p className="fs-smallest">
                                Once candidates apply, they'll appear here for
                                your review.
                              </p>
                            </div>
                          ) : column.name === "ASSESSMENT" ? (
                            <div>
                              {" "}
                              <h4 className="mb-2">
                                No Candidates in Assessment Stage
                              </h4>
                              <p className="fs-smallest">
                                Candidates who have completed their applications
                                and assessments will be shown here.
                              </p>
                            </div>
                          ) : column.name === "INTERVIEW" ? (
                            <div>
                              {" "}
                              <h4 className="mb-2">
                                No Candidates Scheduled for Interview
                              </h4>
                              <p className="fs-smallest">
                                Schedule interviews with candidates who have
                                passed the assessment stage.
                              </p>
                            </div>
                          ) : column.name === "OFFER" ? (
                            <div>
                              {" "}
                              <h4 className="mb-2">No Offers Extended Yet</h4>
                              <p className="fs-smallest">
                                Extend offers to the most qualified candidates
                                to move them to the next stage.
                              </p>
                            </div>
                          ) : column.name === "HIRED" ? (
                            <div>
                              {" "}
                              <h4 className="mb-2">No Candidates Hired Yet</h4>
                              <p className="fs-smallest">
                                Celebrate success by moving hired candidates to
                                this stage.
                              </p>
                            </div>
                          ) : (
                            <div>
                              {" "}
                              <h4 className="mb-2">
                                {" "}
                                No Candidates Rejected Yet
                              </h4>
                              <p className="fs-smallest">
                                Candidates who were not selected for the
                                position will be listed here.
                              </p>
                            </div>
                          )}
                        </div>
                      )}
                    </>
                  )}

                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </div>
        ))}
      </DragDropContext>
    </div>
  );
}

export default CandidateKanbanBoard;
